import { isEmpty, find } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import Selector from '../../Common/Selector';
import Label from '../../Tags/Tag';
import { LabelOptionType } from '@components/CRM/Tickets/types';

export interface ClientLabelsSelectorProps {
  className?: string;
  name?: string;
  dark?: boolean;
  onChange: (event: CustomEvent) => void;
  labels: LabelOptionType[] | null;
  value: string[] | null;
}

const PLACEHOLDER = 'Указать свойство клиента';

const StyledLabel = styled(Label)`
  color: inherit;
  font-size: 14px;
`;

class ClientLabelsSelector extends React.PureComponent<ClientLabelsSelectorProps> {
  el: any = null;

  static defaultProps = {
    className: '',
    name: '',
    dark: false,
    labels: null,
    value: null,
  };

  static getMultiValueContainer = ({ data, innerProps, children }) => {
    const { backgroundColor, textColor: color } = data;

    return (
      <div
        {...innerProps}
        style={{
          backgroundColor,
          color,
        }}
      >
        {children}
      </div>
    );
  };

  static getMultiValueLabel({ data, innerProps }) {
    const { label } = data;

    return (
      <div {...innerProps}>
        <StyledLabel tag={label} />
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  handleChange(value) {
    const { name, onChange } = this.props;

    const formatedValue = Array.isArray(value) ? value.map(v => v.value) : null;
    this.el.name = name;
    this.el.value = formatedValue;

    const event = new CustomEvent('change', {
      bubbles: true,
    });

    this.el.dispatchEvent(event);
    onChange(event);
  }

  handleRef(ref) {
    this.el = ReactDOM.findDOMNode(ref);
  }

  render() {
    const { labels, value, ...props } = this.props;

    if (isEmpty(labels)) {
      return null;
    }

    let formatedValue: (LabelOptionType | undefined)[] | null = null;
    if (Array.isArray(value)) {
      formatedValue = value.map(v => find(labels, { value: v }));
    }

    return (
      <StyledSelector
        {...props}
        components={{
          MultiValueContainer: ClientLabelsSelector.getMultiValueContainer,
          MultiValueLabel: ClientLabelsSelector.getMultiValueLabel,
          ClearIndicator: () => null,
        }}
        isMulti
        isSearchable
        onChange={this.handleChange}
        options={labels}
        placeholder={PLACEHOLDER}
        ref={this.handleRef}
        value={formatedValue}
      >
        {({ label }) => <StyledLabel tag={label} />}
      </StyledSelector>
    );
  }
}

const StyledSelector = styled(Selector)``;

export default ClientLabelsSelector;
